import { createSlice } from "@reduxjs/toolkit";

import { getDashboardData, refreshDashboardData } from "./actions";

const initialState = {
  data: {
    currentStep: null,
  },
  loading: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });

    builder.addCase(getDashboardData.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(refreshDashboardData.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(refreshDashboardData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });

    builder.addCase(refreshDashboardData.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default dashboardSlice.reducer;
